import { render, staticRenderFns } from "./BreakTime.vue?vue&type=template&id=b0ebc854&scoped=true"
import script from "./BreakTime.vue?vue&type=script&lang=js"
export * from "./BreakTime.vue?vue&type=script&lang=js"
import style0 from "./BreakTime.vue?vue&type=style&index=0&id=b0ebc854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ebc854",
  null
  
)

export default component.exports